module.exports = __webpack_public_path__ + "static/media/crai-512.a096a477.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crai-512.png
// module id = 763
// module chunks = 0